/**
 * Leader detection utilities.
 *
 * Leaders are detected by checking if an entity is an OdDbMLeader.
 */

import type { DrawingModuleType } from "../DrawingSingleton";
import type { DrawingModule } from "../types/DrawingWeb";
import { deleteObj } from "../core/delete";
import { OpenMode } from "../core/constants";

/**
 * Check if an entity is a leader (OdDbMLeader).
 */
export function isLeaderEntity(
  module: DrawingModuleType,
  entityId: DrawingModule.OdDbObjectId,
): boolean {
  let entity: DrawingModule.OdDbObject | null = null;
  try {
    entity = entityId.safeOpenObject(OpenMode.kForRead, false);
    const entityClass = entity.isA();
    return entityClass.isEqualTo(module.OdDbMLeader.desc());
  } finally {
    if (entity) deleteObj(entity);
  }
}
